import { getTranslation } from '@services/translations';

export const translations = () =>
  ({
    DROPDOWN_REORDERING_INSTRUCTIONS: getTranslation(
      'survey.RANKING_DROPDOWN_REORDERING_INSTRUCTIONS',
      "Rank the items below by using the dropdown options. Choosing a number will move the item to that position, and the others will adjust accordingly. For example, selecting '1' will place the item at the top and move the current value to '2'."
    ),

    DROPDOWN_REORDERING_STARTED: getTranslation(
      'survey.RANKING_DROPDOWN_REORDERING_STARTED',
      'Reordering #{ITEM} item at #{POSITION}'
    ),

    DROPDOWN_REORDERING_STARTED_UNSET: getTranslation(
      'survey.RANKING_DROPDOWN_REORDERING_STARTED_UNSET',
      'Reordering #{ITEM} item at position unset'
    ),

    DROPDOWN_REORDERING_CANCELED: getTranslation(
      'survey.RANKING_DROPDOWN_REORDERING_CANCELED',
      'Reordering canceled'
    ),

    DROPDOWN_REORDERING_DONE: getTranslation(
      'survey.RANKING_DROPDOWN_REORDERING_DONE',
      'The list has been reordered. #{ITEM} is now item #{POSITION} of #{TOTAL}'
    ),

    DROPDOWN_REORDERING_DONE_UNSET: getTranslation(
      'survey.RANKING_DROPDOWN_REORDERING_DONE_UNSET',
      'The list has been reordered. #{ITEM} is not set'
    )
  }) as const;
